import { render, staticRenderFns } from "./SpecialList.vue?vue&type=template&id=14723c9d"
import script from "./SpecialList.vue?vue&type=script&lang=js"
export * from "./SpecialList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports